import React, { useEffect } from 'react';

import UiStore from 'modules/ui/UiStore';
import PropTypes from 'prop-types';

import '@hotmart/cosmos/dist/dropdown';

import './dropdown.scss';

const MENU_SIDE = {
  LEFT: 'left',
  RIGHT: 'right'
};

const onClick = (e) => {
  if (!UiStore.isMobile) {
    e.stopPropagation();
  }
};

const Dropdown = React.forwardRef(
  (
    { children, onClose, onOpen, className = '', menuSide = MENU_SIDE.LEFT },
    ref
  ) => {
    useEffect(() => {
      const current = ref?.current;

      if (onClose) {
        current?.addEventListener('close', onClose);
      }

      if (onOpen) {
        current?.addEventListener('open', onOpen);
      }

      return () => {
        if (onClose) {
          current?.removeEventListener('close', onClose);
        }

        if (onOpen) {
          current?.removeEventListener('open', onOpen);
        }
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onClose, onOpen]);

    return (
      <hot-dropdown
        class={`hot-dropdocked ${className}`}
        ref={ref}
        onClick={onClick}
        menu-side={menuSide}
      >
        {children}
      </hot-dropdown>
    );
  }
);

Dropdown.MenuHeader = ({ children, className = '' }) => (
  <hot-dropdown-menu-header slot="menu" class={className}>
    {children}
  </hot-dropdown-menu-header>
);

Dropdown.MenuItem = ({ className, disabled = false, ...rest }) => (
  <hot-dropdown-menu-item
    slot="menu"
    class={className}
    {...(disabled && { disabled })}
    {...rest}
  />
);

Dropdown.MenuDivider = ({ className = '' }) => (
  <hot-dropdown-menu-divider
    slot="menu"
    class={`${className} hot-dropdown__divider`}
  />
);

Dropdown.closeMenu = () => {
  const hotDropdown = document.querySelector('hot-dropdown');

  hotDropdown?.closeMenu();
};

Dropdown.MENU_SIDE = MENU_SIDE;

Dropdown.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  menuSide: PropTypes.string,
  onClose: PropTypes.func,
  onOpen: PropTypes.func
};

Dropdown.MenuHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

Dropdown.MenuItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func
};

Dropdown.MenuDivider.propTypes = {
  className: PropTypes.string
};

export default Dropdown;
